import { render } from "./home.vue?vue&type=template&id=aefeac14&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\test\\ieds-mobile-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__